export default __webpack_public_path__ + "assets/code_img.2fcf1bcb.png";